import { render, staticRenderFns } from "./limit.vue?vue&type=template&id=2d84f2e1&scoped=true"
import script from "./limit.vue?vue&type=script&lang=js"
export * from "./limit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d84f2e1",
  null
  
)

export default component.exports